window.arRelationFormatter = function(value, row) {
    let html = '';
    html += '<a href="/ar/relations/show/'+row.relation_id+'">';
    html += value;
    html += '</a>';
    return html;
}
